import { compareEnums } from "@modules/common/functions/compare-enums";
import { getEnumValues } from "@modules/common/functions/get-enum-values";

/**Returns an array of all values in the given enum sorted by their display names. */
export function getSortedEnumValues<T extends number>(enumType: any, enumDescriptions: any, exclude?: T[]): T[] {
    let enumValues = getEnumValues<T>(enumType);
    if (exclude?.length) {
        enumValues = enumValues.filter(x => !exclude.includes(x));
    }

    return enumValues.sort((a, b) => compareEnums(enumDescriptions, a, b));
}